import { defineComponent, ref, computed, watch, createElementBlock, openBlock, withKeys, createElementVNode, createBlock, createVNode, unref, withCtx, Fragment, renderList, createTextVNode, toDisplayString } from "vue";
import { useLoadingState, ScalarSearchInput, ScalarSearchResultList } from "@scalar/components";
import { useDebounceFn } from "@vueuse/core";
import { Client } from "typesense";
import { useRouter } from "vue-router";
import AsciiMag from "./magnifying.ascii.js";
import TypesenseSearchResult from "./TypesenseSearchResult.vue.js";
import FlowAsciiArt from "../../components/FlowAsciiArt.vue.js";
import FlowLoader from "../../components/FlowLoader.vue.js";
const _hoisted_1 = { class: "guides-search-input" };
const _hoisted_2 = {
  key: 0,
  class: "guides-search-empty-state"
};
const _hoisted_3 = {
  key: 1,
  class: "guides-search-empty-state"
};
const _hoisted_4 = {
  key: 2,
  class: "guides-search-loading"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "TypesenseSearch",
  props: {
    typesenseKey: {},
    typesenseHost: {},
    typesenseCollection: {}
  },
  emits: ["close"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const { resolve, push } = useRouter();
    const additionalSearchParameters = {
      query_by: "page_content",
      highlight_affix_num_tokens: 6,
      per_page: 24
    };
    const loading = useLoadingState();
    const client = new Client({
      apiKey: props.typesenseKey,
      // Be sure to use the search-only-api-key fo typesense
      nodes: [
        {
          host: props.typesenseHost,
          port: 443,
          protocol: "https"
        }
      ],
      connectionTimeoutSeconds: 2
    });
    const results = ref([]);
    const query = ref("");
    const activeIndex = ref(0);
    const activeResult = computed(
      () => results.value[activeIndex.value]
    );
    const debouncedQuery = useDebounceFn(async (q) => {
      const search = await client.collections(props.typesenseCollection).documents().search({ q, ...additionalSearchParameters });
      loading.stopLoading();
      results.value = (search.hits || []).map((hit) => {
        var _a;
        return {
          ...hit.document,
          uid: `search-result-${hit.document.page_uid}`,
          snippet: (_a = hit.highlight.page_content) == null ? void 0 : _a.snippet,
          route: resolve({
            name: hit.document.page_uid,
            params: {
              project: hit.document.project_uid,
              version: hit.document.version_uid,
              guide: hit.document.guide_uid
            }
          })
        };
      });
    }, 325);
    watch(query, async (q) => {
      if (q && props.typesenseKey) {
        loading.startLoading();
        debouncedQuery(q);
      } else results.value = [];
    });
    watch(activeResult, (result) => {
      var _a;
      if (!document || !result) return;
      (_a = document.getElementById(result.uid)) == null ? void 0 : _a.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    });
    function changeActiveIndex(dir) {
      const index = activeIndex.value;
      const length = results.value.length;
      activeIndex.value = (index + length + dir) % length;
    }
    function handleNavigate(route) {
      if (!activeResult.value) return;
      push(route ?? activeResult.value.route);
      emit("close");
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "guides-search",
        onKeydown: [
          _cache[1] || (_cache[1] = withKeys(($event) => changeActiveIndex(1), ["down"])),
          _cache[2] || (_cache[2] = withKeys(($event) => handleNavigate(), ["enter"])),
          _cache[3] || (_cache[3] = withKeys(($event) => changeActiveIndex(-1), ["up"]))
        ]
      }, [
        createElementVNode("div", _hoisted_1, [
          createVNode(unref(ScalarSearchInput), {
            modelValue: query.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => query.value = $event)
          }, null, 8, ["modelValue"])
        ]),
        !_ctx.typesenseKey ? (openBlock(), createElementBlock("div", _hoisted_2, _cache[4] || (_cache[4] = [
          createElementVNode("div", null, " On your published sites your content will be fully searchable allowing users to move around your documents with ease ✨ ", -1)
        ]))) : !query.value.length ? (openBlock(), createElementBlock("div", _hoisted_3, [
          createVNode(unref(FlowAsciiArt), {
            art: unref(AsciiMag),
            class: "guides-search-empty-art"
          }, null, 8, ["art"]),
          _cache[5] || (_cache[5] = createElementVNode("div", null, "Type Query Above", -1))
        ])) : unref(loading).isLoading ? (openBlock(), createElementBlock("div", _hoisted_4, [
          createVNode(unref(FlowLoader), {
            isLoading: "",
            size: "36px"
          })
        ])) : (openBlock(), createBlock(unref(ScalarSearchResultList), {
          key: 3,
          class: "guides-search-results custom-scroll",
          noResults: !results.value.length
        }, {
          query: withCtx(() => [
            createTextVNode(toDisplayString(query.value), 1)
          ]),
          default: withCtx(() => [
            (openBlock(true), createElementBlock(Fragment, null, renderList(results.value, (result, index) => {
              return openBlock(), createBlock(TypesenseSearchResult, {
                id: result.uid,
                key: `${index}${result.page_uid}`,
                active: activeIndex.value === index,
                snippet: result.snippet,
                onClick: ($event) => handleNavigate(result.route)
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(result.page_title), 1)
                ]),
                _: 2
              }, 1032, ["id", "active", "snippet", "onClick"]);
            }), 128))
          ]),
          _: 1
        }, 8, ["noResults"])),
        _cache[6] || (_cache[6] = createElementVNode("div", { class: "guides-search-meta" }, [
          createElementVNode("span", null, "↑↓ Navigate"),
          createElementVNode("span", null, "⏎ Select")
        ], -1))
      ], 32);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=TypesenseSearch.vue2.js.map
